var _circle, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#FF2D55"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1252,
    y: 14.25,
    width: 27.75,
    height: 7.125,
    rx: 1.5,
    stroke: "white",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 14.0754L31.7571 10.0774C32.2305 9.79306 32.8316 9.95402 33.0997 10.4369L35.313 14.4247",
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9005 14.0754L18.2434 10.0774C17.7699 9.79306 17.1689 9.95402 16.9008 10.4369L14.6875 14.4247",
    stroke: "white",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 21.375H28.75V29.9044C28.75 30.2847 28.3423 30.5258 28.009 30.3425L25.4819 28.9526C25.1818 28.7876 24.8182 28.7876 24.5181 28.9526L21.991 30.3425C21.6577 30.5258 21.25 30.2847 21.25 29.9044V21.375Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 21.375H37.0002V35.875C37.0002 36.9796 36.1048 37.875 35.0002 37.875H15.0002C13.8956 37.875 13.0002 36.9796 13.0002 35.875V21.375Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGift);
export default __webpack_public_path__ + "static/media/icon-gift.b0780d830bb3386fa0eb80e08c258dc8.svg";
export { ForwardRef as ReactComponent };